import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ThankYouContent } from '../../../../components/FixedBroadbandOrder/ThankYouContent.js';
import { applyWizardEvent } from '../../../../selfservice/actions/index.js';
import { clearFixedBroadbandOrderDraft } from '../../../../selfservice/common/fixedBroadbandOrderStorage.js';

export const FixedBroadbandThankyouPath = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(applyWizardEvent(3, 'FIXED_BROADBAND_ORDER'));
    clearFixedBroadbandOrderDraft();
  }, [dispatch]);

  return <ThankYouContent />;
};
